import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=63a2b6a6&"
import script from "./DesktopNav.vue?vue&type=script&lang=js&"
export * from "./DesktopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports